<ng-container *transloco="let t">
  <span>{{
    t('noResults.noResultsFound', {
      type: type ? type : t('noResults.results')
    })
  }}</span>
</ng-container>
